import React from 'react';

const termsOfUseDefaultContent = (
    <div>
        <p>
          <b>
            § 1 Informacje ogólne
          </b>
        </p>

        <p>
        Niniejszy regulamin określa zasady korzystania z usług elektronicznych w ramach PORTALU E-USŁUG E-SPDP realizowanych przez firmę GIAP Sp. z o.o., która została udostępniona Użytkownikom pod adresem https://e-spdp.pl/.
        PORTAL E-USŁUG E-SPDP pełni funkcję „systemu teleinformatycznego” zgodnie z definicją zawartą w ustawie z dnia 17 lutego 2005 r. o informatyzacji działalności podmiotów realizujących zadania publiczne (t.j. Dz.U. 2019 poz 700  ze zm)  oraz „systemu teleinformatycznego służącego do obsługi doręczeń” Urzędów w rozumieniu przepisów rozporządzenia Prezesa Rady Ministrów z dnia 14 września 2011 r. w sprawie sporządzania i doręczania dokumentów elektronicznych oraz udostępniania formularzy, wzorów i kopii dokumentów elektronicznych (Dz. U. 2018 poz 180)
        </p>
        <p>
          <b>
            § 2 Definicje
          </b>
        </p>

        <p>
          <b>
            PORTAL E-USŁUG E-SPDP
          </b>
            &nbsp;– platforma elektroniczna, która udostępnia Usługi elektroniczne  Usługodawców skierowane do Usługobiorców danej jednostki gminnej.
        </p>

        <p>
          <b>
            Usługobiorca
          </b>
            &nbsp;– osoba fizyczna, osoba prawna albo jednostka organizacyjna nieposiadająca osobowości prawnej, która korzysta z publicznie dostępnych Usług elektronicznych dostarczanych przez platformę PORTAL E-USŁUG E-SPDP.
        </p>

        <p>
          <b>
            Usługodawca
          </b>
            &nbsp;– Podmiot publiczny (określona jednostka gminna) udostępniający swoje usługi poprzez PORTAL E-USŁUG E-SPDP.
        </p>

        <p>
          <b>
            Administrator PORTALU E-USŁUG E-SPDP
          </b>
            &nbsp;– Firma GIAP Sp. z o.o. (ul. Pasaż Ursynowski 1/126, 02-784 Warszawa, NIP: 521-370-98-19, KRS: 581378, REGON: 362764079), która zarządza i administruje portalem.
        </p>

        <p>
          <b>
            Administrator danych osobowych przetwarzanych na PORTALU E-USŁUG E-SPDP
          </b>
            &nbsp;– Firma GIAP Sp. z o.o. (ul. Pasaż Ursynowski 1/126, 02-784 Warszawa, NIP: 521-370-98-19, KRS: 581378, REGON: 362764079).
        </p>

        <p>
          <b>
          ePUAP
          </b>
            &nbsp;– Elektroniczna Platforma Usług Administracji Publicznej - ogólnopolska platforma teleinformatyczna służąca do komunikacji obywateli z jednostkami administracji publicznej w ujednolicony, standardowy sposób na której instytucje publiczne udostępniają usługi przez pojedynczy punkt dostępowy w sieci Internet. Platforma dostępna w Internecie pod adresem
            &nbsp;<a href="https://epuap.gov.pl" target="_blank" style={{ color: 'inherit' }}>
              <b>
                https://epuap.gov.pl
              </b>
            </a>
            &nbsp;
            do której, aby zalogować się należy posiadać profil zaufany na
            &nbsp;<a href="https://pz.gov.pl" target="_blank" style={{ color: 'inherit' }}>
              <b>
              https://pz.gov.pl
              </b>
            </a>
            .
        </p>

        <p>
          <b>
            Profil zaufany
          </b>
            &nbsp;– środek identyfikacji elektronicznej zawierający zestaw danych identyfikujących i opisujących osobę fizyczną, który został wydany w sposób, o którym mowa w art. 20c ustawy z dnia 17 lutego 2005 r. o informatyzacji działalności podmiotów realizujących zadania publiczne (Dz. U. z 2019 r. poz. 700 ze zm).
        </p>

        <p>
          <b>
            Regulamin
          </b>
            &nbsp;– niniejszy dokument.
        </p>

        <p>
          <b>
            Usługa elektroniczna
          </b>
            &nbsp;– usługa świadczona drogą elektroniczną poprzez sieć telekomunikacyjną z wykorzystaniem technologii informacyjnej, której świadczenie jest zautomatyzowane i która wymaga niewielkiego udziału człowieka.
        </p>

        <p>
          <b>
            Uwierzytelnienie
          </b>
            &nbsp;– proces polegający na potwierdzeniu zadeklarowanej tożsamości Usługobiorcy biorącego udział w procesie komunikacji i zlecającego wykonanie usługi elektronicznej, za pomocą Węzła Krajowego.
        </p>

        <p>
          <b>
            Węzeł Krajowy
          </b>
            &nbsp;- Węzeł Krajowy jest rozwiązaniem organizacyjno-technicznym umożliwiającym uwierzytelnianie użytkownika systemu teleinformatycznego, korzystającego z usługi online, z wykorzystaniem środka identyfikacji elektronicznej wydanego w systemie identyfikacji elektronicznej przyłączonym do tego węzła bezpośrednio albo za pośrednictwem węzła transgranicznego.
        </p>

        <p>
          <b>
            Użytkownik PORTALU E-USŁUG E-SPDP
          </b>
            &nbsp;łączne określenie Usługobiorcy i Usługodawcy.
        </p>

        <p>
          <b>
            § 3 Ogólne zasady korzystania z PORTALU E-USŁUG E-SPDP
          </b>
        </p>
        <p>
          Usługobiorca zobowiązany jest do zapoznania się z treścią Regulaminu przed rozpoczęciem korzystania z PORTALU E-USŁUG E-SPDP.<br/>
          Usługobiorca zobowiązany jest do korzystania z PORTALU E-USŁUG E-SPDP w sposób zgodny z obowiązującym prawem, normami społecznymi i obyczajowymi, powszechnie obowiązującymi zasadami korzystania z sieci Internet oraz postanowieniami niniejszego Regulaminu.<br/>
          Korzystanie z PORTALU E-USŁUG E-SPDP jest bezpłatne. Opłaty mogą być wymagane jedynie w ramach realizacji konkretnych usług, w których konieczne jest wniesienia opłaty o ile przepisy prawa taką opłatę przewidują.<br/>
          PORTAL E-USŁUG E-SPDP udostępnia treści ogólnodostępne dedykowane dla wszystkich Usługobiorców oraz treści dostępne dla Usługobiorców zalogowanych.<br/>
          Aby Usługobiorca zrealizował Usługę elektronicznie, konieczne jest logowanie za pomocą Węzła Krajowego.<br/>
          Z chwilą pierwszego zalogowania Usługobiorca oświadcza, że wyraża zgodę na przetwarzanie, gromadzenie, utrwalanie, przechowywanie, opracowywanie i usuwanie danych adresowych (w tym adresu e-mail) przez Administratora PORTALU E-USŁUG E-SPDP oraz Usługodawców, a w szczególnych przypadkach także innych danych, ale tylko w zakresie niezbędnym do świadczenia Usług elektronicznych i na zasadach zgodnych z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE.<br/>
          Do wymiany danych przekazywanych przez Usługobiorców wykorzystywana jest platforma ePUAP.<br/>
          Dane o Usługobiorcach będą wykorzystywane tylko do wykonywania zadań statutowych Usługodawców, a w szczególności w celu poprawnej realizacji Usług elektronicznych.<br/>
          Usługobiorcom przysługuje prawo dostępu do swoich danych oraz ich poprawiania.<br/>
          Usługobiorca może w każdym czasie odwołać zgody, o których mowa powyżej, co będzie równoznaczne z rezygnacją z korzystania Usług.<br/>
          Usługodawca zastrzega sobie prawo do zawieszenia konta Usługobiorcy, który narusza prawo lub postanowienia Regulaminu.
        </p>

        <p>
          <b>
            § 4 Prawa i obowiązki Usługodawcy
          </b>
        </p>
        <p>
          Administrator PORTALU E-USŁUG E-SPDP gwarantuje, iż Usługi elektroniczne świadczone są zgodne z przepisami polskiego prawa.<br/>
          Usługodawca nie ponosi odpowiedzialności za jakiekolwiek działania Usługobiorcy bądź osoby upoważnionej przez Usługobiorcę do działania w jego imieniu.<br/>
          Usługodawca zobowiązuje się podejmować niezbędne działania w celu wyeliminowania nielegalnych lub niezgodnych z Regulaminem działań Usługobiorców.<br/>
          Usługodawca zobowiązany jest do ochrony danych osobowych Usługobiorców zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE.
        </p>

        <p>
          <b>
            § 5 Prawa i obowiązki Usługobiorcy
          </b>
        </p>
        <p>
          Zabrania się korzystania z kont innych Usługobiorców oraz udostępniania swojego konta innym osobom lub podmiotom.<br/>
          Zakazuje się Użytkownikowi dostarczania treści niezgodnych z przeznaczeniem Platformy i formularzy. Administrator PORTALU E-USŁUG E-SPDP nie ponosi odpowiedzialności za działania Użytkownika, sprzeczne z prawem.
        </p>
        <p>
          <b>
            § 6 Rodzaj i zakres Usług
          </b>
        </p>
        <p>
          Usługobiorcy mają możliwość przeglądu treści ogólnodostępnych na PORTALU E-USŁUG E-SPDP.<br/>
          Usługi dostępne w PORTALU E-USŁUG E-SPDP są świadczone przez określone jednostki gminne zgodnie z listą udostępnioną  na PORTALU E-USŁUG E-SPDP danej jednostki gminnej.<br/>
          Na PORTALU E-USŁUG E-SPDP znajduje się wykaz Usług elektronicznych w podziale na: urzędy i kategorie.<br/>
          PORTAL E-USŁUG E-SPDP umożliwia załatwienie spraw na trzy sposoby: przez PORTAL E-USŁUG E-SPDP i ePUAP, osobiście w urzędzie oraz poprzez pocztę tradycyjną.<br/>
          Udostępnione usługi elektroniczne posiadają kartę informacyjną e-usługi oraz formularze elektroniczne i wnioski tradycyjne.<br/>
          Usługodawcy odpowiadają za wprowadzone przez siebie treści na kartach usług oraz za przyłączone do tych kart dokumenty, w tym formularze.
        </p>

        <p>
          <b>
            § 7 Wysyłanie i odbieranie dokumentów
          </b>
        </p>

        <p>
          PORTAL E-USŁUG E-SPDP umożliwia Usługobiorcy interaktywne wypełnianie formularzy, elektroniczne dokonanie opłaty skarbowej i wysyłanie korespondencji elektronicznej.<br/>

          Dokumenty elektroniczne doręczane do Urzędów za pomocą PORTALU E-USŁUG E-SPDP powinny być zgodnie z przepisami rozporządzenia Prezesa Rady Ministrów z dnia 14 września 2011 r. w sprawie sporządzania i doręczania dokumentów elektronicznych oraz udostępniania formularzy, wzorów i kopii dokumentów elektronicznych (Dz. U. 2018 poz. 180  z późn.zm.) i uwierzytelnione przy użyciu mechanizmów określonych w art. 20a ust. 1 albo ust. 2 ustawy z dnia 17 lutego 2005 r. o informatyzacji działalności podmiotów realizujących zadania publiczne (Dz. U. z 2019 r. poz.700 ze zm ).<br/>
          Brak wymaganego podpisu stanowi brak formalny, który może zostać usunięty w trybie art. 64 K.P.A.<br/>
          Dokument uznaje się za dostarczony do Urzędu po dostarczeniu Urzędowego Potwierdzenia Odbioru (UPO), wygenerowanego i odesłanego automatycznie po zarejestrowaniu dokumentu w Elektronicznej Skrzynce Podawczej Urzędu. Jako datę dostarczenia Dokumentu uznaje się datę i godzinę doręczenia dokumentu elektronicznego wystawioną na UPO.<br/>
          W przypadku, gdy realizacja usługi jest uzależniona od wniesienia opłaty, a Urząd udostępnia możliwość wniesienia opłaty drogą elektroniczną, Usługobiorca korzystając z możliwości wniesienia opłaty drogą elektroniczną wyraża automatycznie  zgodę na doliczenie do opłaty należnej Urzędowi lub innej instytucji, prowizji dla operatora płatności elektronicznych w stawce przez niego stosowanej.<br/>
          Poświadczenie doręczenia jest udostępniane przez Urząd w celu umożliwienia podpisania tego poświadczenia przez adresata dokumentu elektronicznego i zawiera zakres danych opisany w przepisach rozporządzenia Prezesa Rady Ministrów z dnia 14 września 2011 r. w sprawie sporządzania pism w formie dokumentów elektronicznych, doręczania dokumentów elektronicznych oraz udostępniania formularzy, wzorów i kopii dokumentów elektronicznych.<br/>
          Adresat dokumentu elektronicznego potwierdza na platformie ePUAP jego odebranie przez opatrzenie poświadczenia doręczenia podpisem elektronicznym umożliwiającym identyfikację podpisującego w sposób określony w art. 20a ust. 1 lub 2 ustawy z dnia 17 lutego 2005 r. o informatyzacji działalności podmiotów realizujących zadania publiczne.<br/>
          Po opatrzeniu poświadczenia doręczenia podpisem elektronicznym, system teleinformatyczny służący do obsługi doręczeń bezpośrednio po zakończeniu procesu weryfikacji podpisu elektronicznego adresata udostępnia adresatowi do pobrania doręczany dokument elektroniczny wraz z podpisanym przez niego poświadczeniem doręczenia.
        </p>

        <p>
          <b>
            § 8 Ochrona danych osobowych
          </b>
        </p>
        <p>
          Usługodawca gwarantuje ochronę danych i informacji o Usługobiorcy zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE.<br/>
          Usługodawca nie ponosi odpowiedzialności za nieuprawnioną zmianę danych lub dostęp do informacji przeznaczonej dla Usługobiorcy przez osoby trzecie, przy użyciu oryginalnych identyfikatorów Usługobiorcy.<br/>
          Usługodawca zapewnia Usługobiorcom możliwość usunięcia swojego konta. Usunięcie konta następuje na wniosek właściciela konta złożony przez PORTAL E-USŁUG E-SPDP w Profilu Użytkownika.
        </p>

        <p>
          <b>
            § 9 Reklamacje
          </b>
        </p>
        <p>
          Wszelkie reklamacje dotyczące wykonywania Usługi wynikające z nieznajomości bądź z faktu nieprzestrzegania Regulaminu nie będą rozpatrywane.
        </p>

        <p>
          <b>
            § 10 Postanowienia końcowe
          </b>
        </p>

        <p>
          Regulamin obowiązuje od dnia jego opublikowania na stronie. <br/>
          W kwestiach nieuregulowanych Regulaminem stosuje się odpowiednie przepisy obowiązującego prawa.<br/>
          Administrator PORTALU E-USŁUG E-SPDP zastrzega sobie prawo zmiany treści niniejszego Regulaminu. Zmiany Regulaminu wchodzą w życie po opublikowaniu tych zmian na stronie internetowej o ile w Regulaminie nie zastrzeżono inaczej.<br/>
          W przypadku zmiany treści Regulaminu, Usługobiorca zostanie o tym fakcie poinformowany podczas uwierzytelniania dostępu do konta Usługobiorcy.<br/><br/>
          Regulamin obowiązuje od dnia 15.01.2024 r.
        </p>

      </div>);


export default termsOfUseDefaultContent;


// WEBPACK FOOTER //
// src/components/utils/termsOfUse/constants.js